import { IntlTFunc } from 'next-intl';

import { ProductAttributeSortInput, SortField } from '@/fo/api/magento';

import { FilterOption } from './types';

export const SORT_DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const;

export const SORT_OPTIONS_MAP: Record<
  string,
  {
    direction: keyof typeof SORT_DIRECTION;
    value: keyof ProductAttributeSortInput;
  }
> = {
  popularityDesc: {
    direction: SORT_DIRECTION.DESC,
    value: 'popularity'
  },
  newProductsDesc: {
    direction: SORT_DIRECTION.DESC,
    value: 'new'
  },
  discountDesc: {
    direction: SORT_DIRECTION.DESC,
    value: 'discount'
  },
  priceAsc: {
    direction: SORT_DIRECTION.ASC,
    value: 'price'
  },
  priceDesc: {
    direction: SORT_DIRECTION.DESC,
    value: 'price'
  }
};

export const SORT_OPTIONS = (t: IntlTFunc): (SortField & FilterOption)[] => [
  {
    value: 'popularityDesc',
    label: t('sortOptions.popularity')
  },
  {
    value: 'newProductsDesc',
    label: t('sortOptions.news')
  },
  // Скрыли во время релиза, бек пока не поддерживет
  // {
  //   value: 'discountDesc',
  //   label: t('sortOptions.discount')
  // },
  {
    value: 'priceAsc',
    label: t('sortOptions.priceAsc')
  },
  {
    value: 'priceDesc',
    label: t('sortOptions.priceDesc')
  }
];

export const DEFAULT_SORT_OPTION = SORT_OPTIONS_MAP.popularityDesc;
